import React, { Suspense, lazy } from 'react';
import { useAssistantChat } from 'context/assistant-chat-context';

// Lazy load the AssistantChat component
const AssistantChat = lazy(() => import('./AssistantChat'));

const AssistantChatContainer = () => {
	const {
		isSidebarOpen,
		isMinimized,
		isFullscreen,
		closeSidebar,
		minimizeSidebar,
		maximizeSidebar,
		fullscreenSidebar,
		exitFullscreen
	} = useAssistantChat();

	// Only render when sidebar is open or fullscreen
	if (!isSidebarOpen && !isFullscreen) {
		return null;
	}

	return (
		<Suspense fallback={<div>Loading chat...</div>}>
			<AssistantChat 
				isOpen={isSidebarOpen} 
				isMinimized={isMinimized}
				isFullscreen={isFullscreen}
				onClose={closeSidebar}
				onMinimize={minimizeSidebar}
				onMaximize={maximizeSidebar}
				onFullscreen={fullscreenSidebar}
				onExitFullscreen={exitFullscreen}
			/>
		</Suspense>
	);
};

export default AssistantChatContainer;
